<template>
    <div>
       <div class="prism-player" id="J_prismPlayer"></div>
    </div>
</template>
<script>
/* eslint-disable */

export default {
    name:'ctu',
    data(){
        return{
            videoInfo:{

            }
        }
    },
    components:{
        
    },
    methods:{
        init(){
            var player = new Aliplayer({
                id: "J_prismPlayer", // 容器id
                vid : '5bdc61942f6d4422b347ea4aa535e9e8',
                playauth : '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',
                format: 'm3u8',
                mediaType: 'video',
                width: '100%',
                height: '210px',
                autoplay: true,
                rePlay: false,
                preload: true,
                controlBarVisibility: 'hover',
                useH5Prism: true,
                playsinline: true, //H5是否内置播放
                language: 'zh-cn',
                }, function (player) {
                    console.log("The player is created");
                }
            );
        }
    },
    mounted() {
        this.init();
    },
}
</script>
